import React, { Fragment } from "react";
import Hamburger from "react-hamburgers";
import { connect } from "react-redux";
import logo from "../../assets/utils/images/logo.png";
import {
  setEnableMobileMenu,
  setEnableMobileMenuSmall,
} from "../../reducers/ThemeOptions";
import MobileHelper from "../../_helpers/mobileHelper";
import RunningActivityHelper from "../../_helpers/runningActivityHelper";
import { userService } from "../../_services/user.service";
import UserBox from "../AppHeader/Components/UserBox";

class AppMobileMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      mobile: false,
      activeSecondaryMenuMobile: false,
      runningActivity: null,
    };
    this.currentUser = userService.getLoggedInUser();
  }

  componentDidMount() {
    this.menuStatusObservable = MobileHelper.menuStatusObservable.subscribe(
      (val) => {
        if (val !== null) {
          let { setEnableMobileMenu } = this.props;
          setEnableMobileMenu(false);
        }
      }
    );
    this.runningActivityObservable = RunningActivityHelper.runningActivityObservable.subscribe(
      (val) => {
        this.setState({
          runningActivity: val == null ? null : val.isPaused ? null : val,
        });
      }
    );
  }

  componentWillUnmount() {
    this.runningActivityObservable.unsubscribe();
  }

  toggleMobileSidebar = () => {
    let { enableMobileMenu, setEnableMobileMenu } = this.props;
    setEnableMobileMenu(!enableMobileMenu);
  };

  toggleMobileSmall = () => {
    let { enableMobileMenuSmall, setEnableMobileMenuSmall } = this.props;
    setEnableMobileMenuSmall(!enableMobileMenuSmall);
  };

  state = {
    openLeft: false,
    openRight: false,
    relativeWidth: false,
    width: 280,
    noTouchOpen: false,
    noTouchClose: false,
  };

  render() {
    let { enableMobileMenu } = this.props;

    return (
      <Fragment>
        <div className="app-header__mobile-menu">
          <div onClick={this.toggleMobileSidebar}>
            <Hamburger
              active={enableMobileMenu}
              type="elastic"
              onClick={() => {
                this.setState({ activeMobile: !this.state.activeMobile });
              }}
            />
          </div>
          <img
            className="logo"
            src={logo}
            width="50"
            style={{ marginLeft: "20px" }}
          />
        </div>
        <div className="app-header__menu">
          {this.currentUser !== undefined && this.currentUser != null && (
            <UserBox
              name={`${this.currentUser.firstName} ${
                this.currentUser.lastName
              }`}
            />
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
  setEnableMobileMenuSmall: (enable) =>
    dispatch(setEnableMobileMenuSmall(enable)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppMobileMenu);
